import React from "react";
import {Modal} from "antd";
import styled from "styled-components";

const StyledModal = styled(Modal)`
    .ant-modal-content {
        border-radius: 10px;
        overflow: hidden;
    }

    .ant-modal-header {
        background: linear-gradient(135deg, #cf1322 100%, #ff4d4f 0%);
        border-bottom: none;
        border-radius: 10px 10px 0px 0px;
        margin: 0;
        padding: 16px 20px;
    }

    .ant-modal-title {
        color: white !important;
        font-weight: 600;
    }

    .ant-modal-close {
        color: white !important;
    }

    .ant-modal-close:hover {
        color: #ffccc7 !important;
    }

    .ant-modal-body {
        padding: 24px;
        background-color: white;
        margin: 0;
    }

    .ant-modal-body p {
        font-size: 16px;
        margin-top: 16px;
        line-height: 1.8;
        color: #333;
        margin-bottom: 16px;
    }

    .ant-modal-body ul {
        margin-top: 8px;
        padding-left: 20px;
    }

    .ant-modal-body li {
        margin-bottom: 8px;
        color: #cf1322;
        font-weight: 500;
    }

    .ant-modal-footer {
        border-top: 1px solid #f0f0f0;
        padding: 16px 24px;
        margin: 0;
        border-radius: 0px 0px 10px 10px;
    }

    .ant-modal-footer .ant-btn {
        height: 40px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 6px;
    }

    .ant-modal-footer .ant-btn-default {
        border: 1px solid #d9d9d9;
        color: #333;
        background: white;
    }

    .ant-modal-footer .ant-btn-default:hover {
        border-color: #cf1322;
        color: #cf1322;
    }

    .ant-modal-footer .ant-btn-primary {
        background-color: #cf1322;
        border-color: #cf1322;
        color: white;
    }

    .ant-modal-footer .ant-btn-primary:hover {
        background-color: #ff4d4f;
        border-color: #ff4d4f;
    }
`;

export const MissingDocumentsModal = ({
    visible,
    onCancel,
    title = "Vergi Numarası Eksik",
    onOk
}) => {
    return (
        <StyledModal
            visible={visible}
            title={title}
            onCancel={onCancel}
            okText={"Tamam"}
            onOk={onOk}
            cancelButtonProps={{style: {display: "none"}}}
        >
            <p>
                Vergi numaranız sistemimizde kayıtlı değildir.
                <br />
                Sağ alttaki robottan canlı desteğe başvurarak bize ulaşabilirsiniz.
            </p>
        </StyledModal>
    );
};
